export class Navigation {
  text: string;
  route: string;
  child: Array<Navigation>;
  external: boolean;
  links?: any;

  constructor(text: string, route: string, child: Array<Navigation> = [], external = false) {
    this.text = text;
    this.route = route;
    this.child = child;
    this.external = external;
  }
}
